import * as TK from 'components/common/DeletionDialog/translations/constants';
import { Translations } from 'translations/types';

export const deletionDialogEnUsLocale: Translations = {
  [TK.DELETION_DIALOG_TITLE]: 'Delete?',
  [TK.DELETION_DIALOG_CONFIRM_BUTTON_LABEL]: 'YES',
  [TK.DELETION_DIALOG_DISMISS_BUTTON_LABEL]: 'NO',
  [TK.DELETION_DIALOG_ICON_ALT]: 'Delete icon',
};
